import { ModalFooter, ModalFooterButton } from '@/components/Modal'
import { useTexts } from '../hooks/useTexts'
import { useOnCancel, useOnConfirm } from './ContextProvider'

export function Footer() {
  const texts = useTexts()
  const onConfirm = useOnConfirm()
  const onCancel = useOnCancel()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton onClick={onConfirm} testid="modal-primary-button" variant="contained">
          {texts.footer.save}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton testid="modal-secondary-button" onClick={onCancel}>
          {texts.footer.cancel}
        </ModalFooterButton>
      }
    />
  )
}
